import { connect } from 'react-redux';
import PurchaseDetails from './purchase_details';
import { purchaseSuccess, purchaseOnBack } from '../../../actions/chat';
import { cancelChatOnPP } from '../../../actions/connected_chat';
import {
  voipPurchaseSuccess, voipPurchaseOnBack, voipPurchaseSuccessOnContinue, cancelVoipChatOnPP
} from '../../../actions/voip_chat';
import { purchaseSuccess as sideMenuPurcahseSuccess } from '../../../actions/funds';
import {
  purchaseSuccess as affiliatePromoPurcahseSuccess,
  hideAffiliatePromoPopup,
  noThanksLinkClickedAction
} from '../../../actions/affiliate_promo_popup';
import { doneChangingPaymentSource, changingPaymentSource } from '../../../actions/purchase_details';
import {
  loadPaymentOptions, reset, loadPaymentOptionsOnClose
} from '../../../actions/payment_options';
import {
  loadAvailable, addSource, startEditingPaymentSource,
  managePaymentSource, onMakeDefault, cleanUp, removeSource,
  doneManagingPaymentSource,
  editPaymentSource, updatePaymentSource, clearAddingCardError,
  doneAddCard, editCardIfSecurityReasons
} from '../../../actions/payment_sources';
import withTranslation from '../../../config/withPGTranslation';
import Const from '../../../config/const';

const mapStateToProps = ({
  chat,
  voipChat,
  user: { user },
  user: { loading },
  purchaseDetails,
  paymentOptions,
  paymentSources,
  creditCardValidateProcessing,
  affiliatePromoPopup: { onCloseIconClick },
  application
}, { chatType }) => {
  switch (chatType) {
    case Const.chatType.text:
      return ({
        ...chat,
        ...user,
        purchaseDetails,
        options: paymentOptions.options,
        paymentSources,
        loadingSources: paymentSources.loading || loading || creditCardValidateProcessing.validating,
        loadingOptions: paymentOptions.loading,
        creditCardValidateError: creditCardValidateProcessing.error,
        affiliatePromoPopupOnCloseIconClick: onCloseIconClick,
        userBonusInfos: user && user.bonusInfos,
        anonymousUserBonusInfos: application && application.anonymousUser && application.anonymousUser.bonusInfos,
        userXfmProgram: user && user.xfmProgram,
        userId: user && user.id
      });
    case Const.chatType.voice:
    case Const.chatType.video: {
      return ({
        ...voipChat,
        ...user,
        purchaseDetails,
        options: paymentOptions.options,
        paymentSources,
        loadingSources: paymentSources.loading || loading || creditCardValidateProcessing.validating,
        loadingOptions: paymentOptions.loading,
        creditCardValidateError: creditCardValidateProcessing.error,
        affiliatePromoPopupOnCloseIconClick: onCloseIconClick,
        userBonusInfos: user && user.bonusInfos,
        anonymousUserBonusInfos: application && application.anonymousUser && application.anonymousUser.bonusInfos,
        userXfmProgram: user && user.xfmProgram,
        userId: user && user.id
      });
    }
    default:
      return null;
  }
};

const defaultFunctions = (dispatch, ownProps) => ({
  affiliatePromoPurcahseSuccess: () => {
    dispatch(affiliatePromoPurcahseSuccess(ownProps.chatType, ownProps.needUpdatePricingOptions));
  },
  doneChangingPaymentSource: () => dispatch(doneChangingPaymentSource()),
  loadAvailable: (forceReload) => dispatch(loadAvailable(forceReload)),
  addSource: (kind) => dispatch(addSource(kind)),
  startEditingPaymentSource: (id) => dispatch(startEditingPaymentSource(id)),
  managePaymentSource: (id) => dispatch(managePaymentSource(id)),
  onMakeDefault: (history, location, makeDefParams) => dispatch(
    onMakeDefault(history, location, makeDefParams)
  ),
  cleanUp: () => dispatch(cleanUp()),
  removeSource: (id) => dispatch(removeSource(id)),
  doneManagingPaymentSource: () => dispatch(doneManagingPaymentSource()),
  editPaymentSource: (id) => dispatch(editPaymentSource(id)),
  updatePaymentSource: (paymentSourceParams) => dispatch(updatePaymentSource(paymentSourceParams)),
  doneAddCard: () => dispatch(doneAddCard()),
  clearAddingCardError: () => dispatch(clearAddingCardError()),
  loadPaymentOptions: (params) => dispatch(loadPaymentOptions(params)),
  loadPaymentOptionsOnClose: () => dispatch(loadPaymentOptionsOnClose()),
  changingPaymentSource: (changing) => dispatch(changingPaymentSource(changing)),
  reset: () => dispatch(reset()),
  hideAffiliatePromoPopup: () => dispatch(hideAffiliatePromoPopup()),
  noThanksLinkClickedAction: () => dispatch(noThanksLinkClickedAction()),
  editCardIfSecurityReasons: (id, kind) => dispatch(editCardIfSecurityReasons(id, kind))
});

const mapDispatchToProps = (dispatch, ownProps) => {
  switch (ownProps.chatType) {
    case Const.chatType.text:
      return ({
        purchaseSuccess: () => dispatch(purchaseSuccess()),
        cancelChatOnPP: () => dispatch(cancelChatOnPP(ownProps.isContinue)),
        purchaseOnBack: () => dispatch(purchaseOnBack()),
        sideMenuPurcahseSuccess: () => dispatch(sideMenuPurcahseSuccess()),
        ...defaultFunctions(dispatch, ownProps)
      });
    case Const.chatType.voice:
    case Const.chatType.video:
      const voipPurchaseSuccessAction = ownProps.isContinue ? voipPurchaseSuccessOnContinue() : voipPurchaseSuccess(); //eslint-disable-line
      return ({
        purchaseSuccess: () => dispatch(voipPurchaseSuccessAction),
        cancelChatOnPP: () => dispatch(cancelVoipChatOnPP(ownProps.isContinue)),
        purchaseOnBack: () => dispatch(voipPurchaseOnBack()),
        sideMenuPurcahseSuccess: () => dispatch(sideMenuPurcahseSuccess()),
        ...defaultFunctions(dispatch, ownProps)
      });
    default:
      return null;
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(PurchaseDetails));
